<section class="products-base" id="products-base">

    <app-header class="shopping--active"></app-header>
    
    <div class="page">
        <div class="box-title">
            <div class="container">
                <h1 *ngIf="planType === 1" class="title-one">Arma tu plan en 2 pasos</h1>
                <p *ngIf="planType === 1" class="title-description">¡Es muy fácil! Te acompañamos paso a paso.</p>
                <!-- Ideal-plans -->
                <h1 *ngIf="planType === 2" class="title-one">Escoge tu plan ideal</h1>
                <p *ngIf="planType === 2" class="title-description">Tenemos diferentes opciones para ti, puedes encontrar la mejor opción para tu empresa.</p>
            </div>
        </div>
        <div class="grid container">
            <div class="grid-12 grid-lg-8 container-base">
                <h2 *ngIf="!isFullPlan" class="title-two"><span class="icon">1</span>Agrega la base</h2>
                <div class="alert alert-bg-warning notification" role="alert" *ngIf="isSaveTransactionFail">
                    <div class="line"></div>
                    <div class="icon_notification"></div>
                    <span class="ico-close icon-close" data-close="close"></span>
                    <p class="message_notification">Tuvimos un inconveniente con el pago. Por favor, inténtalo nuevamente.</p>
                </div>
                <div class="alert alert-bg-warning notification" role="alert" *ngIf="isUpdateUserInformationRequiered">
                    <div class="line"></div>
                    <div class="icon_notification"></div>
                    <span class="ico-close icon-close" data-close="close"></span>
                    <p class="message_notification">Para continuar, es necesaria una actualización de datos.</p>
                </div>
                <!-- plan seleccionado -->
                <h2 *ngIf="isFullPlan" class="title-two title-two--check"><span class="icon icon-checkmark"></span>Ya tienes el plan base</h2>
                <!--<div class="base-box" *ngFor="let item of plans; index as i">
                    <app-base-card [dataPlan]='plans[i]' [selectedOne]='isSelectedPlan' (setSelectedPlan)='onSelectedPlan($event)'>
                    </app-base-card>
                </div>-->
                <div *ngIf="existPlan" class="base-card bg-gradient-blue-3">
                    <div class="base-card-content">
                        <div class="base-card__image">
                            <picture>
                                <source media="(min-width: 960px)" srcset="{{image_url + imagen_static}}.png">
                                <img class="img-responsive" src="{{image_url + imagen_static}}-mobile.png" alt="happy people image">
                            </picture>
                            <div class="text-mobile">
                                <div class="text-content-image">
                                    <div class="text-content-children">
                                        <p>Base Seleccionada</p>
                                        <p class="price-size"><span>{{titleChild}}</span><br> ${{mesPlan}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="base-card__description">
                            <div class="text-desktop">
                                <p>Base Seleccionada</p>
                                <ul class="list-li">
                                    <li *ngIf="titleChild != ''"><p class="price-size" style="font-weight: bold;">{{titleChild}}</p></li>
                                    <li>
                                        <p class="price-size"> ${{mesPlan}}</p>
                                    </li>
                                </ul>
                            </div>
                            <span class="line-bottom"></span>
                            <span class="aprove">Selecciona la cantidad de meses que necesitas</span>
                            <div *ngFor="let item of plans; index as i">
                                <app-base-card [dataPlan]='plans[i]' [selectedOne]='isSelectedPlan' (setSelectedPlan)='onSelectedPlan($event)'>
                                </app-base-card>
                            </div>
                            <span class="text-mobile line-bottom"></span>
                            <button style="margin: 10px 0 10px 0;" class="button tertiary px-small py-xsmall rounded text-xsmall text-desktop" type="button" (click)="selectPlan()">Añadir a carrito</button>
                            <button style="margin: 10px 0 10px 0;" class="button size-safari tertiary px-small py-xsmall rounded text-xsmall top-div text-mobile" type="button" (click)="selectPlan()">Añadir a carrito</button>
                        </div> 
                    </div> 
                    <span class="line-bottom text-desktop"></span>
                    <ul class="summary-parent">
                        <li *ngFor="let item of ListSummary; index as i">
                            <span class="icon icon-check_circle_outline"></span>
                            <label> {{ item }} </label>
                        </li>
                    </ul>
                </div>

                <!-- plan seleccionado -->

                <div class="container-products curve-top--right">
                    <div class="container p-base">
                        <h2 class="title-two"><span class="icon">2</span>Agrega productos adicionales</h2>

                        <div class="product-box product-box--dash">
                            <h3 class="title-three">Tour por tus inmuebles</h3>
                            <p class="title-three-description">¡Todo entra por los ojos! Mueve más rápido tus propiedades con estas herramientas de visualización.</p>

                            <div class="grid product-card-box">
                                <ng-container *ngFor="let item of products; index as i">
                                    <app-product-card class="grid-12 grid-sm-6" *ngIf="item.prodCategory  === 1" [productData]='item' [dataIndex]='i'>
                                    </app-product-card>
                                </ng-container>
                            </div>

                        </div>
                        <div class="product-box product-box--dash">
                            <h3 class="title-three">Relevancia para tus publicaciones</h3>
                            <p class="title-three-description">Solo puedes destacar o ascender un inmueble a la vez.</p>
                            <div class="grid product-card-box">
                                <ng-container *ngFor="let item of products; index as i">
                                    <app-product-card class="grid-12 grid-sm-6" *ngIf="item.prodCategory  === 2" [productData]='item' [dataIndex]='i'>
                                    </app-product-card>
                                </ng-container>
                            </div>

                        </div>
                        <div class="product-box">
                            <h3 class="title-three">Conoce el valor del inmueble</h3>
                            <p class="title-three-description">Vende o arrienda más rápido con el precio correcto de tu inmueble.</p>

                            <div class="grid product-card-box">
                                <ng-container *ngFor="let item of products; index as i">
                                    <app-product-card class="grid-12 grid-sm-6" *ngIf="item.prodCategory  === 3" [productData]='item' [dataIndex]='i'>
                                    </app-product-card>
                                </ng-container>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-12 grid-lg-4 d-none d-lg-block container-checkout">
                <app-resume></app-resume>
            </div>
        </div>
    </div>
    <lib-cc-footer [ccEnvironment]="ccEnvironment"></lib-cc-footer>
</section>
<app-shopping-bar></app-shopping-bar>